/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import * as React from "react";

import { Card, CardHeader } from "../../packages/fluent9";

import { getCardHeaderImageProps, getCardHeaderProps, getCardProps } from "./SelectableList.mappers";
import { SelectableListProps } from "./SelectableListProps";

/**
 * Renders a selectable list of items that can be selected.
 * @param props The properties.
 * @returns The selectable list.
 */
export const SelectableList: React.FC<SelectableListProps> = props => {
    const { ariaLabel, items } = props;

    return (
        <section aria-label={ariaLabel} role="list">
            {
                items
                .sort((a, b) => a.label.localeCompare(b.label))
                .map(item => {
                    const cardProps = getCardProps(props, item);
                    const cardHeaderProps = getCardHeaderProps(item);
                    const cardHeaderImageProps = getCardHeaderImageProps(item);
                    const image = cardHeaderImageProps ? <img alt={item.label} {...cardHeaderImageProps} /> : undefined;

                    return (
                        <Card key={item.value} role="listitem" {...cardProps}>
                            <CardHeader {...cardHeaderProps} image={image} />
                        </Card>
                    );
                })}
        </section>
    );
};
